<template>
<div>

<ContentHeader :title="title"  url="SupplierProjects" :show_button="true" icon="arrow-left" buttontype="primary" :label="$store.state.languages.lang_phrases.geri_don" v-if="title!==''"></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card_content" v-if="!loading">


<div class="mt-4">
<ContentTableExtended :data="list" :columns="columns" routename="SupplierProject"  @dataDeleted="getData" identifier_row="uuid" identifier_row_name="project_id"></ContentTableExtended>
</div>



</div>



</div>
</template>

<script>
export default {

  name: 'SupplierProjectAllPeriods',

  data () {
    return {
    	loading:true,
    	data:null,
    	list:[],
    	columns:[  
      {
        type:"text",
        field:"projectperiod", 
        header:"proje_periyodu",
        hide_on_mobile:false,
        with_route:true,
      },
      {
        type:"pill",
        field:"active_flow_status",
        header:"durum",
        options:[
          {
            name:"created",
            color:"#352f8d",
            text:"olusturuldu",
          },
          {
            name:"viewed",
            color:"#7e2f8d",
            text:"goruntulendi",
          },
          {
            name:"started",
            color:"#dd4b39",
            text:"baslandi",
          },
          {
            name:"finished",
            color:"#4dc247",
            text:"tamamlandi0",
          },
          {
            name:"under_review",
            color:"#ff6600",
            text:"degerlendirmede",
          },
          {
            name:"canceled",
            color:"#a82400",
            text:"iptal_edildi",
          },
          {
            name:"correction_requested",
            color:"#3b82f6",
            text:"duzeltme_talebi_incelemede",
          },
        ],
      },
      {
        type:"text",
        field:"activeflow",
        header:"aktif_akis",
        hide_on_mobile:false,
      },
      {
        type:"pill",
        field:"flowtype",
        header:"tur",
        options:[
          {
            name:"self_evaluation",
            color:"#ff6600",
            text:"self_evaluation",
          },
          {
            name:"education",
            color:"#3b82f6",
            text:"egitim",
          },
          {
            name:"verification",
            color:"#7e2f8d",
            text:"verification",
          },
          {
            name:"audit",
            color:"#352f8d",
            text:"audit",
          },
        ],
      }, 
      
      {
        type:"boolean",
        field:"verified",
        header:"verified",
        hide_on_mobile:false,
      },
      ]
    }
  },
  computed:{
  	title()
  	{
  		if(this.data && this.data.project)
  		{
  			return this.getTheTranslation(this.data.project,"translation")
  		}
  		return ""
  	}
  },
  mounted()
  {
  	
  	this.getData()
  },
  methods:{
  	async getData()
    {
      this.loading = await true
      this.data = await this.generalApiGetWithoutLoader("supplier/project_suppliers/"+this.$route.params.id+"/"+this.$route.params.project_id) 
      console.log(this.data);
      for(let item of this.data.projectsuppliers)
      {
        console.log(item)
        let active_flowsupplier = {status:null,name:null,type:null}
        let activeflow ={name:null,type:null}
        if(item.activeflow)
        {
          
          let test_active_flowsupplier = item.activeflow.suppliers.find(element=>element.projectperiod_id == item.projectperiod_id) 
          activeflow = item.activeflow
          if(test_active_flowsupplier)
          {
            active_flowsupplier = test_active_flowsupplier
          }
         
        }
        
        
      	     	 
      	let element = {
      		projectperiod:item.projectperiod,
      		active_flow_status:active_flowsupplier.status,
      		activeflow:activeflow,
      		flowtype:activeflow.type,
      		verified:item.verified,
      		uuid:item.uuid
      	}
      	this.list.push(element)
      }
      this.loading = await false
  	}
  }
}
</script>

<style lang="css" scoped>
</style>